import { render, staticRenderFns } from "./WooVariantsListArchiveTab.vue?vue&type=template&id=2726f0e3"
import script from "./WooVariantsListArchiveTab.vue?vue&type=script&lang=js"
export * from "./WooVariantsListArchiveTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports